// extracted by mini-css-extract-plugin
export default {"buttonWrapper":"buttonWrapper-524e"};